import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollGroup  {
    _originalTypeClassName = "zERP.BO.PayrollGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollGroup.translate = translateService;
}
this.children = [];
this.key = null;
this.PayrollGroupKey = null;
this._key = this.PayrollGroupKey = 0; 
}

static translate: TranslateService;
_key: any;
key:any;
children:any;
data:any;
private _PayrollGroupKey:any;
get PayrollGroupKey(): any {
    return this._PayrollGroupKey;
  }
set PayrollGroupKey(value: any) {
    this._PayrollGroupKey = value;
    this._key = value;
  }
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.PayrollGroup.removechildren($this, $this.children[0]);
                }

                Domain.PayrollGroup.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollGroup.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollGroup.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
}
static clearchildren = ($this) => { $this.children = null; }
static setdata = ($this, value) => {
var oldValue = $this.data;
$this.data = value;
if (value != null) {
}
}

static Fill(mode: any,payroll: any): any{let employeesMode = mode == "employees" || mode == "";
let groups = [];
for (let _icalculation = 0; _icalculation < (payroll?.Calculations == null ? 0 : payroll?.Calculations.length); _icalculation++) {let calculation = payroll?.Calculations[_icalculation];for (let _iempPayroll = 0; _iempPayroll < (calculation?.Employees == null ? 0 : calculation?.Employees.length); _iempPayroll++) {let empPayroll = calculation?.Employees[_iempPayroll];let idToSearch = (employeesMode ? empPayroll?.Employee?.Id : calculation?.Id);let existingGroup = groups?.linq?.where((g) => CLMS.Framework.Number.Equal(() => g.key, () => idToSearch))?.firstOrDefault(null);if (existingGroup == null) {existingGroup = new Domain.PayrollGroup();Domain.PayrollGroup.setdata(existingGroup, new Domain.PayrollGroupData());existingGroup.key = idToSearch;existingGroup.data.Name = (employeesMode ? empPayroll?.Employee?.Code + " - " + empPayroll?.Employee?.Fullname : calculation?.Period?.Name + " - " + calculation?.Type?.Name);groups?.add(existingGroup);}let line = new Domain.PayrollGroup();Domain.PayrollGroup.setdata(line, new Domain.PayrollGroupData());line.key = (employeesMode ? empPayroll?.Employee?.Id : calculation?.Id);line.data.Name = (!(employeesMode) ? empPayroll?.Employee?.Code : calculation?.Period?.Name);line.data.Description = (!(employeesMode) ? empPayroll?.Employee?.Fullname : calculation?.Type?.Name);line.data.DaysWorked = empPayroll?.DaysWorked;line.data.DaysInsured = empPayroll?.DaysInsured;line.data.TotalSalary = empPayroll?.TotalSalary;line.data.AdvanceAmount = empPayroll?.AdvanceAmount;line.data.EmployeeContributions = empPayroll?.EmployerContributions;line.data.EmployeeDeductions = empPayroll?.EmployeeDeductions;line.data.EmployerContributions = empPayroll?.EmployerContributions;line.data.EmployerDeductions = empPayroll?.EmployerDeductions;line.data.Tax = empPayroll?.Tax;existingGroup?.children?.add(line);}}
return groups;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollGroupKey == null || $this.PayrollGroupKey == 0;
            }


}